import { render, staticRenderFns } from "./PushNotificationManager.vue?vue&type=template&id=b5ae3c56"
import script from "./PushNotificationManager.vue?vue&type=script&lang=js"
export * from "./PushNotificationManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports